module.exports = __webpack_public_path__ + "assets/media/guillaume-cabane.5067829a.svg";